import React from "react";
import { AlertTriangle, X, Trash2 } from "lucide-react";

const ConfirmDeleteProduct = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/60 backdrop-blur-lg z-[45000] transition-all" />

      {/* Modal */}
      <div
        className="fixed inset-0 flex items-center justify-center z-[55000] px-4"
        dir="rtl"
      >
        <div className="animate-in fade-in slide-in-from-bottom-4 duration-300">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl max-w-md w-full shadow-2xl">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-800">
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 ">
              <div className="flex items-center text-center  mx-auto space-x-reverse space-x-3">
                <div className="w-10 h-10  bg-red-500/10 rounded-full flex items-center justify-center">
                  <AlertTriangle className="w-5 h-5 text-red-500" />
                </div>
                <h3 className="text-lg font-semibold text-white">
                  تأكيد الحذف
                </h3>
              </div>
              <p className="text-gray-300 text-right mt-4">
                هل أنت متأكد أنك تريد حذف هذا المنتج؟ لا يمكن التراجع عن هذا
                الإجراء.
              </p>
            </div>

            {/* Actions */}
            <div className="flex items-center justify-between space-x-reverse space-x-3 px-6 py-4 bg-gray-800/50">
              <button
                onClick={onConfirm}
                className="flex items-center space-x-reverse space-x-2 px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
              >
                <Trash2 className="w-4 h-4 ml-2" />
                <span>حذف المنتج</span>
              </button>
              <button
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white bg-gray-800 hover:bg-gray-700 rounded-lg transition-colors"
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmDeleteProduct;
